<div class="modal-header">
  <h5 class="modal-title">Edit device name</h5>
</div>
<div class="modal-body">
  <form [formGroup]="renameForm">
    <div class="d-flex flex-row">
      <label class="form-label"
             for="name">Device name</label>
      <fa-icon class="flex-shrink-0 ms-2"
               [icon]="['fas', 'circle-info']"
               [ngbTooltip]="'Leave empty to remove the name.'" />
    </div>
    <div>
      <input type="text"
             placeholder="Name"
             class="form-control mb-1"
             id=""
             formControlName="desiredName" />
    </div>
    @if (renameForm?.invalid) {
      <div class="text-danger">
        The name may only contain alphanumerics, spaces, or a '-'. The maximum length is 10.
      </div>
    }
  </form>
</div>
<div class="modal-footer">
  <button class="btn btn-primary"
          (click)="closeModal()">Cancel</button>
  <button class="btn btn-primary"
          [disabled]="renameForm?.invalid"
          (click)="save()">Save</button>
</div>